<div class="logo">
    <!--<img class="logo" src="/assets/utu/logo_fi.png" alt="university_logo" routerLink="environment.redirectRoute">-->
    <a class="logo" routerLink= "{{frontPageRoute}}" (click)="closeMobileNav()">
        <img src="{{logoLocation}}_{{globals.lang}}.png" alt="university_logo" />
       </a>
</div>


   

<div class="term-selection" *ngIf="showTermSelection">

    <button mat-icon-button color="primary" class="material-icons valign-wrapper" [attr.aria-label]="curriculumPeriods[periodIndex - 1]" [disabled]="!(selectedSchoolYear > firstSchoolYear)" (click)="decrease()" (keydown)="decrease2($event)" tabindex="0">
        <mat-icon>chevron_left</mat-icon>
    </button>

    <!--<span *ngIf="!period">{{selectedSchoolYear}}-{{selectedSchoolYear + curriculumPeriod}}</span>-->
    <span *ngIf="period">{{period}}</span>
    
    <button mat-icon-button color="primary" class="material-icons valign-wrapper" [attr.aria-label]="curriculumPeriods[periodIndex + 1]" [disabled]="!(selectedSchoolYear < currentPeriodStartYear)" (click)="increase()" (keydown)="increase2($event)" tabindex="0">
        <mat-icon>chevron_right</mat-icon>
    </button>

</div>
<!--<div [ngClass]="{'no-term-selection': !showTermSelection}" class="search" *ngIf="showSearchField && selectedSchoolYear===currentPeriodStartYear"> 
    <div class="search-wrapper card grey lighten-3">
        <label id="searchLabel" for="search" *ngIf="placeholder" hidden>{{globals.getLocalizedValue(placeholder)}}</label>
        <input #searchField id="search" type="text" [(ngModel)]='searchParams' (keyup.enter)="search()" *ngIf="placeholder" placeholder="{{globals.getLocalizedValue(placeholder)}}" [ngClass]="{'accent-1': true, 'green': searchParams.length>3, 'red': (searchParams.length>0 && searchParams.length<4)}" autocomplete="off" > 
        <i class="material-icons" (click)="search()">search</i>
    </div>
</div>-->

<!--<form class="search-form">
    <mat-form-field class="search-field">
        <input class="search-input" matInput placeholder="Search" value="" name="search" [(ngModel)]= "search" >
        <button matSuffix mat-button><mat-icon >search</mat-icon></button>
    </mat-form-field>
</form>-->

<mat-card *ngIf="showSearchField && selectedSchoolYear===searchPeriod">
    <input aria-label="Search" type="text" class="search" matInput placeholder="{{globals.getLocalizedValue(placeholder)}}" minlength="4" [ngClass]="{'valid' : searchParams.length>3, 'invalid': (searchParams.length>0 && searchParams.length<4)}" autocomplete="off"  [(ngModel)]="searchParams" (keyup.enter)="search()">
    <button  mat-button (click)="search()"><mat-icon >search</mat-icon></button>
</mat-card>

<!--<div *ngIf="name.invalid && (name.dirty || name.touched)"
    class="alert">

  <div *ngIf="name.errors?.['required']">
    Name is required.
  </div>
  <div *ngIf="name.errors?.['minlength']">
    Name must be at least 4 characters long.
  </div>
  <div *ngIf="name.errors?.['forbiddenName']">
    Name cannot be Bob.
  </div>

</div>-->
<!--<form class="example-form">
    <mat-form-field class="example-full-width">
      <mat-label>Email</mat-label>
      <input type="email" matInput [formControl]="emailFormControl" 
             placeholder="Ex. pat@example.com">
      <mat-hint>Errors appear instantly!</mat-hint>

    </mat-form-field>
  </form>-->
  



<!--<mat-tab-group *ngIf="isMobile" class="my-tab-class">
    <mat-tab label="First"> 
        <div *ngIf="!period" class="nav-content">
            <mat-nav-list>
                <div *ngFor="let item of navigationItems">
                    <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o">{{globals.getLocalizedNavigationItem(item.name)}}</a>
                    <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                    <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                </div>

                <div *ngFor="let lang of globals.languages">
                    <a mat-list-item *ngIf="lang" (click)="changeLang(lang)" [ngClass]="{'light-blue darken-1': lang===globals.lang}" tabindex="0" (keydown)="changeLang2($event, lang)">{{lang | uppercase}}</a>
                </div>
            </mat-nav-list>
        </div>
        
        <div *ngIf="period" class="nav-content">
            <mat-nav-list>
                <div *ngFor="let item of navigationItems">
                    <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}}</a>
                    <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                    <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                </div>

                <div *ngFor="let lang of globals.languages">
                    <a mat-list-item *ngIf="lang" (click)="changeLang(lang)" [ngClass]="{'light-blue darken-1': lang===globals.lang}" tabindex="0" (keydown)="changeLang2($event, lang)">{{lang | uppercase}}</a>
                </div>
        
            </mat-nav-list>
        </div>
    </mat-tab>
    <mat-tab label="Second"> 
        <div class="nav-content">
            <mat-nav-list>

                <div *ngFor="let link of links">
                    <a mat-list-item href = "{{globals.getLocalizedValue(link.url)}}">{{globals.getLocalizedValue(link.name)}}</a>
                </div>
            </mat-nav-list>
        </div>
    </mat-tab>
</mat-tab-group>-->

<div *ngIf="!period && isMobile" class="nav-content">
            <mat-nav-list>
                <div *ngFor="let item of navigationItems">
                    <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}}</a>
                    <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                    <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                </div>

                <div *ngFor="let lang of globals.languages">
                    <a mat-list-item *ngIf="lang" (click)="changeLang(lang)" [ngClass]="{'light-blue darken-1': lang===globals.lang}" tabindex="0" (keydown)="changeLang2($event, lang)">{{lang | uppercase}}</a>
                </div>
            </mat-nav-list>
        </div>
        
        <div *ngIf="period && isMobile" class="nav-content">
            <mat-nav-list>
                <div *ngFor="let item of navigationItems">
                    <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o" [queryParams]="{period: period}" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}}</a>
                    <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/" [queryParams]="{period: period}" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                    <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e" [queryParams]="{period: period}" (click)="closeMobileNav()">{{globals.getLocalizedNavigationItem(item.name)}} </a>
                </div>

                <div *ngFor="let lang of globals.languages">
                    <a mat-list-item *ngIf="lang" (click)="changeLang(lang)" [ngClass]="{'light-blue darken-1': lang===globals.lang}" tabindex="0" (keydown)="changeLang2($event, lang)">{{lang | uppercase}}</a>
                </div>
        
            </mat-nav-list>
        </div>


<!--<div class="nav-content">
    <mat-nav-list>
        <mat-list-item><a routerLink="/fi/perustutkintokoulutus/14002/o">Perustutkintokoulutus</a></mat-list-item>
        <mat-list-item><a routerLink="/fi/index">Kandidaattiohjelmat</a></mat-list-item>
        <mat-list-item><a routerLink="/">Maisteriohjelmat</a></mat-list-item>
    </mat-nav-list>
</div>-->

<div *ngIf="!period && !isMobile" class="nav-content">
    <mat-nav-list>
        <div *ngFor="let item of navigationItems">
            <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o">{{globals.getLocalizedNavigationItem(item.name)}}</a>
            <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/">{{globals.getLocalizedNavigationItem(item.name)}} </a>
            <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e">{{globals.getLocalizedNavigationItem(item.name)}} </a>
        </div>
    </mat-nav-list>
</div>

<div *ngIf="period && !isMobile" class="nav-content">
    <mat-nav-list>
        <div *ngFor="let item of navigationItems">
            <a mat-list-item *ngIf="item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/o" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}}</a>
            <a mat-list-item *ngIf="!item.organisationView && item.type == 'code'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}} </a>
            <a mat-list-item *ngIf="item.type == 'organisation_unit'" routerLinkActive="active" routerLink="{{globals.lang}}/{{globals.toKebabCase(globals.getLocalizedNavigationItem(item.name))}}/{{item.id}}/e" [queryParams]="{period: period}">{{globals.getLocalizedNavigationItem(item.name)}} </a>
        </div>
    </mat-nav-list>
</div>


